import { useEffect } from "react";
import { Button } from "@/components/ui/button";

/** Public return page contains no account amounts or payment claims. Only an
 * authenticated receipt check on the finance screen can confirm settlement. */
export default function AccountPaymentReturn() {
  const params = new URLSearchParams(window.location.search),
    storeId = Number(params.get("storeId")),
    id = params.get("debtPayment") ?? "";
  const valid =
    Number.isSafeInteger(storeId) && storeId > 0 && /^[0-9a-f-]{36}$/i.test(id);
  const target = valid
    ? `/business/finance/${storeId}?debtPayment=${encodeURIComponent(id)}`
    : "/business";
  useEffect(() => {
    if (valid && localStorage.getItem("ayrshire_token"))
      window.location.replace(target);
  }, [target, valid]);
  return (
    <main className="max-w-lg mx-auto px-5 py-12 space-y-5">
      <h1 className="text-2xl font-bold">Return to your business account</h1>
      <p className="text-slate-600">
        Your account updates once Stripe confirms the payment. If you came from
        the app, close this window to return and check your balance.
      </p>
      {valid && (
        <Button asChild className="w-full">
          <a href={`ayrshirehub://store-finance?storeId=${storeId}`}>
            Return to the Ayrshire Hub app
          </a>
        </Button>
      )}
      <Button asChild variant="outline" className="w-full">
        <a href={`/login?returnTo=${encodeURIComponent(target)}`}>
          Sign in to check your balance on the web
        </a>
      </Button>
    </main>
  );
}
